import React from 'react';

const DateTimeDisplay = ({ value, type, isDanger }) => (
  <div className={isDanger ? 'countdown danger' : 'countdown'}>
    <p className="notranslate">
      {typeof value === 'number' ? String(value).padStart(2, '0') : value}
    </p>
    <span>{type}</span>
  </div>
);

export default DateTimeDisplay;
